import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"

export default class extends Controller {

  connect() {
    const organization = this.element.dataset.organization
    const showUnread = this.showUnread
    const tab = this.tab

    this.subscription = consumer.subscriptions.create(
      { channel: "PollInstanceChannel", room: organization },
      {
        connected() {},
        disconnected() {},
        received(data) {
          $('#polls-none-open').remove()
          const $data = $(data)
          const id = $data.attr("id")
          if ($(`#${id}`).length == 0) {
            $data.prependTo("#polls-tab")
          } else{
            $(`#${id}`).replaceWith( $data )
          }
          showUnread(tab)
        }
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  removeUnread() {
    this.tab.classList.remove('unread')
  }

  get tab(){
    const tabName = this.element.dataset.tab
    return document.querySelector(`.tabs-dashboard [data-tab="${tabName}"]`)
  }

  showUnread(tab){
    if (!tab.classList.contains('active')) {
      tab.classList.add("unread")
    }
  }

}

